import React from "react";
import { ProductFormValues } from "../../../types/product/ProductFormValues";
import { useProduct } from "../../../hooks/useProduct";
import Checkbox from "../../Forms/Input/Checkbox";

interface Props {
  form: ProductFormValues;
  onChange: (field: keyof ProductFormValues, value: any) => void;
}

const ProductConsumableSection: React.FC<Props> = ({ form, onChange }) => {
  const { formErrors } = useProduct();

  return (
    <div className="flex flex-col gap-3">
      <Checkbox
        label="Es un producto consumible"
        checked={!!form.consumable}
        onChange={() => onChange("consumable", !form.consumable)}
      />

      {formErrors.consumable && (
        <p className="text-sm text-red dark:text-red">
          {formErrors.consumable}
        </p>
      )}
    </div>
  );
};

export default ProductConsumableSection;
